var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"google-sso-button-wrap"},[(_vm.googleClientId && !_vm.isAuthenticated)?_c('div',{staticClass:"google-sso-button"}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }